export function unreachable(_: never): never {
  throw Error('graphql-voyager: Unreachable code triggered!');
}
